<div>
  <label [for]="id" class="block text-sm/6 font-medium text-gray-900">{{ label }}</label>
  <div class="relative">
    <input
      [id]="id"
      type="text"
      [placeholder]="placeholder"
      autocomplete="off"
      class="block w-full rounded-md bg-white py-1.5 pr-12 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-1 focus:-outline-offset-1 focus:outline-focus/70 focus:shadow-sm sm:text-sm/6 transition duration-300 ease-in-out"
      [value]="searchTerm()"
      (input)="onSearch($event)"
      (focus)="toggleDropdown()"
    />

    <ul
      *ngIf="isOpen()"
      @fadeInOut
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm"
      id="options"
      role="listbox"
    >
      <li
        *ngFor="let option of filteredOptions()"
        class="relative py-2 pr-9 pl-3 text-gray-900 select-none cursor-pointer hover:bg-primary/30"
        (click)="selectOption(option.key, option.value)"
      >
        <div class="flex items-center">
          <span class="ml-1 truncate">{{ option.value }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
